/**
 * This file defines the platform color schemes.
 */

export const lightScheme = {
  primary: '#E8E6E3',
  secondary: '#E8E6E3',
  separator: '#313131',
  stroke: '#E9E9E9',
  grey: '#5C5C5C',
  defaultShadow: '0px 4px 7px 4px rgba(0, 0, 0, 0.25)',
  background: {
    primary: '#FFFFFF',
    secondary: '#F5F5F5',
    tertiary: '#888A8B',
  },
  text: {
    primary: '#555555',
    secondary: '#888A8B',
  },
  tooltip: {
    background: '#080808',
    text: '#C2C8CA',
  },
  territorialUnits: {
    indigenousLand: '#C40460',
    protectedArea: '#00AA58',
  },
  miningProcesses: {
    miningConcession: '#FF0021',
    smallScaleMining: '#DF374E',
    miningResearchAuthorization: '#FF6846',
    miningResearchRequest: '#CEB62B',
    smallScaleMiningRequest: '#8AB128',
    availableMiningArea: '#008BBB',
  },
  button: {
    primary: '#047FC4',
    primaryHover: '#005d91',
    focused: '#202223',
    active: '#5b5d5d',
    selected: '#404040',
    selectedHover: '#4f4f4f',
  },
  share: {
    twitter: '#00acee',
    whatsapp: '#128c7E',
    facebook: '#3B5998',
  },
  grouping: {
    company: '#C4B204',
    state: '#047FC4',
    reserve: '#C40460',
    unity: '#00AA58',
    substance: '#128c7E',
    reserveEthnicity: '#FF6846',
    year: '#FF0021',
    use: '#E8E6E3',
    requirementPhase: '#3B5998',
    reservePhase: '#DF374E',
  },
  loader: {
    primary: '#00acee',
  },
};

export const darkScheme = {
  primary: '#E8E6E3',
  secondary: '#E8E6E3',
  separator: '#313131',
  grey: '#5C5C5C',
  defaultShadow: '0px 4px 7px 4px rgba(0, 0, 0, 0.25)',
  background: {
    primary: '#181A1B',
    secondary: '#1F1F1F',
  },
  text: {
    primary: '#E8E6E3',
    secondary: '#5C5C5C',
    tertiary: '#888A8B',
  },
  tooltip: {
    background: '#080808',
    text: '#C2C8CA',
  },
  territorialUnits: {
    indigenousLand: '#C40460',
    protectedArea: '#00AA58',
    mapIndigenousLand: '#791F49',
    mapProtectedArea: '#005C53',
  },
  miningProcesses: {
    miningConcession: '#FF0021',
    smallScaleMining: '#DF374E',
    miningResearchAuthorization: '#FF6846',
    miningResearchRequest: '#CEB62B',
    smallScaleMiningRequest: '#8AB128',
    availableMiningArea: '#008BBB',
  },
  button: {
    primary: '#047FC4',
    primaryHover: '#005d91',
    focused: '#202223',
    active: '#5b5d5d',
    selected: '#404040',
    selectedHover: '#4f4f4f',
  },
  share: {
    twitter: '#00acee',
    whatsapp: '#128c7E',
    facebook: '#3B5998',
  },
  grouping: {
    company: '#C4B204',
    state: '#047FC4',
    reserve: '#C40460',
    unity: '#00AA58',
    substance: '#128c7E',
    reserveEthnicity: '#FF6846',
    year: '#FF0021',
    requirementPhase: '#3B5998',
    reservePhase: '#DF374E',
  },
  loader: {
    primary: '#00acee',
  },
};
